import {useNavigate, useParams} from "react-router-dom"
import {useEffect, useState} from "react"
import {Button, Checkbox, Form, InputNumber, Radio, Row, Space, Typography} from "antd"
import {sessionService} from "services/session.service"
import Label from "components/Label"

const Text = Typography
const CheckboxGroup = Checkbox.Group

export default function MedicalForm() {
	const navigate = useNavigate()
	const {sessionId} = useParams()
	const [medicalInfo, setMedicalInfo] = useState(null)
	const [form] = Form.useForm()

	const updateData = () => sessionService.findMedicalInformationPreset(sessionId).then(setMedicalInfo)
	useEffect(updateData, [sessionId])
	useEffect(() => form.resetFields(), [medicalInfo, form])

	const submit = (values) => {
		values.otherDiseases = []
		sessionService.provideMedicalInformation(sessionId, values)
		.then(() => navigate(`/doctor/session/${sessionId}/`))
	}

	return (
		<div className="element">
			<div className="ant-descriptions-title titleText">Medizinische Informationen</div>
			<Form
				form={form}
				name="medicalInfo"
				onFinish={submit}
				requiredMark={false}
				initialValues={medicalInfo}
			>
				<div className="preferences docprefs description">
					<details>
						<summary>
							<Text strong={true}>
								Allgemeine Angaben
							</Text>
						</summary>
						<div className="description">
							<Form.Item name="age" label="Alter">
								<InputNumber min={0}/>
							</Form.Item>
							<Form.Item name="sex" label="Geschlecht">
								<Radio.Group>
									<Radio value="MALE">männlich</Radio>
									<Radio value="FEMALE">weiblich</Radio>
									<Radio value="OTHER">sonstiges</Radio>
								</Radio.Group>
							</Form.Item>
							<Form.Item name="lengthOfPsychosisInMonths" label="Länge der Erkrankung in Monaten">
								<InputNumber/>
							</Form.Item>
						</div>
					</details>
				</div>

				<div className="preferences docprefs knownDiseases">
					<details>
						<summary>
							<Text strong={true}>
								Ist eine der folgenden Erkrankungen bekannt?
							</Text>
						</summary>
						<div className="description">
							<Form.Item name="knownDiseases">
								<CheckboxGroup>
									<Space direction="vertical" size="large">
										<Row>
											<Checkbox value="CARDIAC">
												<Text>
													kardiale Erkrankung
												</Text>
											</Checkbox>
										</Row>
										<Row>
											<Checkbox value="EPILEPSY">
												<Text>
													Epilepsie
												</Text>
											</Checkbox>
										</Row>
										<Row>
											<Checkbox value="LIVER">
												<Text>
													Erkrankung der Leber
												</Text>
											</Checkbox>
										</Row>
										<Row>
											<Checkbox value="KIDNEY">
												<Text>
													Erkrankung der Niere
												</Text>
											</Checkbox>
										</Row>
										<Row>
											<Checkbox value="OBESITY">
												<Text>
													Adipositas
												</Text>
											</Checkbox>
										</Row>
										<Row>
											<Checkbox value="DIABETES">
												<Text>
													Diabetes mellitus
												</Text>
											</Checkbox>
										</Row>
										<Row>
											<Checkbox value="LIPID_METABOLISM">
												<Text>
													Fettstoffwechselstörungen
												</Text>
											</Checkbox>
										</Row>
										<Row>
											<Checkbox value="BLOOD_COUNT">
												<Text>
													Blutbildveränderungen
												</Text>
											</Checkbox>
										</Row>
										<Row>
											<Checkbox value="COGNITIVE">
												<Text>
													kognitive Veränderungen/Demenzen
												</Text>
											</Checkbox>
										</Row>
									</Space>
								</CheckboxGroup>
							</Form.Item>
						</div>
					</details>
				</div>

				<div className="preferences docprefs groups">
					<details>
						<summary>
							<Text strong={true}>
								Gehört ihr Patient/ ihre Patientin einer der folgenden Gruppen an?
							</Text>
						</summary>
						<div className="description">
							<Form.Item name="groups">
								<CheckboxGroup>
									<Space direction="vertical" size="large">
										<Row>
											<Checkbox value="ADOLESCENT">
												<Text>
													Jugendliche
												</Text>
											</Checkbox>
										</Row>
										<Row>
											<Checkbox value="SENIOR">
												<Text>
													Senioren
												</Text>
											</Checkbox>
										</Row>
										<Row>
											<Checkbox value="SUBSTANCE_ABUSE">
												<Text>
													komorbider Substanzmissbrauch
												</Text>
											</Checkbox>
										</Row>
										<Row>
											<Checkbox value="NEGATIVE_SYMPTOMS">
												<Text>
													überwiegend Negativsymptome
												</Text>
											</Checkbox>
										</Row>
										<Row>
											<Checkbox value="STABLE">
												<Text>
													psychiatrisch stabile/r Patient*in
												</Text>
											</Checkbox>
										</Row>
										<Row>
											<Checkbox value="THERAPY_RESISTANT">
												<Text>
													Therapieresistenz
												</Text>
											</Checkbox>
										</Row>
										<Row>
											<Checkbox value="PREGNANT">
												<Text>
													Schwangere
												</Text>
											</Checkbox>
										</Row>
									</Space>
								</CheckboxGroup>
							</Form.Item>
						</div>
					</details>
				</div>

				<Button size="large" form="medicalInfo" key="submit" htmlType="submit" type="primary">
					<Label id="save"/>
				</Button>
			</Form>
		</div>
	)

}
